import { useBoolean } from '@dreryk/react-common';

import { OnlinePaymentsUpdateTermsOfServiceDocumentModal } from './OnlinePaymentsUpdateTermsOfServiceDocumentModal';

type OnlinePaymentsUpdateTermsOfServiceDocumentModalOpenerRenderProps = {
   openModal: VoidFunction;
};

type OnlinePaymentsUpdateTermsOfServiceDocumentModalOpenerProps = {
   readonly children: (renderProps: OnlinePaymentsUpdateTermsOfServiceDocumentModalOpenerRenderProps) => JSX.Element;
};

export const OnlinePaymentsUpdateTermsOfServiceDocumentModalOpener = (
   props: OnlinePaymentsUpdateTermsOfServiceDocumentModalOpenerProps
): JSX.Element => {
   const [{ setTrue: openModal, setFalse: closeModal }, modalOpened] = useBoolean();

   return (
      <>
         {props.children({ openModal: openModal })}
         {modalOpened ? <OnlinePaymentsUpdateTermsOfServiceDocumentModal onCancel={closeModal} /> : null}
      </>
   );
};
